import { render, staticRenderFns } from "./HeatmapsSessions.vue?vue&type=template&id=3c6b7f76&scoped=true"
import script from "./HeatmapsSessions.vue?vue&type=script&lang=js"
export * from "./HeatmapsSessions.vue?vue&type=script&lang=js"
import style0 from "./HeatmapsSessions.vue?vue&type=style&index=0&id=3c6b7f76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6b7f76",
  null
  
)

export default component.exports